import * as ActionTypes from './types';

export function getCriteriaWithFilters(payload) {
  return {
    type: ActionTypes.GET_CRITERIA_WITH_FILTERS,
    payload: payload
  }
}

export function getCriteriaWithFiltersSuccess(payload) {
  return {
    type: ActionTypes.GET_CRITERIA_WITH_FILTERS_SUCCESS,
    payload: payload
  }
}

export function getCriteriaWithFiltersFailed(payload) {
  return {
    type: ActionTypes.GET_CRITERIA_WITH_FILTERS_FAILED,
    payload: payload
  }
}

export function changeCriteriaState(payload) {
    return {
        type: ActionTypes.CHANGE_CRITERIA_STATE,
        payload: payload
    }
}

export function getCriteria(payload) {
  return {
    type: ActionTypes.GET_CRITERIA,
    payload: payload
  }
}

export function getCriteriaSuccess(payload) {
  return {
    type: ActionTypes.GET_CRITERIA_SUCCESS,
    payload: payload
  }
}

export function getCriteriaFailed(payload) {
  return {
    type: ActionTypes.GET_CRITERIA_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/criteria.js